/* global document */
import Home from './home';
import Hosting from './hosting';
import Technology from './technology';
import About from './about';
import Archiving from './archiving';
import Global from './global';

import * as cookies from 'js-cookie';

document.addEventListener('DOMContentLoaded', () => {
  const g = new Global();
  g.init();

  if (document.body.classList.contains('home')) {
    const home = new Home();
    home.init();
  }
  if (document.body.classList.contains('hosting')) {
    const hosting = new Hosting();
    hosting.init();
  }
  if (document.body.classList.contains('technology')) {
    const technology = new Technology();
    technology.init();
  }
  if (document.body.classList.contains('about-us')) {
    const about = new About();
    about.init();
  }
  if (document.body.classList.contains('archiving')) {
    const archiving = new Archiving();
    archiving.init();
  }

  function xhr(endpoint, method, data) {
    return new Promise(function (resolve, reject) {
        var xhr = new XMLHttpRequest();

        xhr.open(method, endpoint, true);
        xhr.setRequestHeader("Content-Type", "application/json");

        xhr.timeout = 20000;
        xhr.ontimeout = function () { reject(); }

        xhr.onreadystatechange = function () {
            if (xhr.readyState === 4) {
                if (xhr.status === 200) { resolve(xhr); }
                if (xhr.status === 202) { resolve(xhr); }
                if (xhr.status === 404) { resolve(xhr); }
                if (xhr.status === 400) { resolve(xhr); }
                if (xhr.status === 500) { reject(); }
                if (xhr.status !== 200) { reject(); }
            }
        }
        method == 'GET' ? xhr.send() : xhr.send(JSON.stringify(data));
    })
  }


  let forms = document.querySelectorAll('.form-subscribe');
  forms.forEach((form) => {
    form.addEventListener('submit', (event) => {
      event.preventDefault();
      event.stopPropagation();

      const inputs = event.target.querySelector('.input-wrapper');
      const button = event.target.querySelector('button');
      const field = event.target.querySelector('input[name=email]');

      const signupSource = event.target.getAttribute('data-gtmsource');

      if (!button.classList.contains('ready')) {
        return;
      }

      field.readOnly = true;
      button.classList.remove('ready');
      button.classList.add('loading');
      inputs.classList.remove('success');
      inputs.classList.remove('error');

      xhr('https://x2xhw1l4vf.execute-api.eu-west-2.amazonaws.com/production/subscribe', 'POST', {
        email: field.value
      })
      .catch( error => {
        field.readOnly = false;
        button.classList.remove('loading');
        button.classList.add('ready');
        inputs.classList.add('error');
        inputs.classList.remove('success');
        throw error;
      })
      .then( response => {
        return JSON.parse(response.responseText);
      })
      .then( response => {
        if (response.success == true) {
          field.readOnly = true;
          button.classList.remove('loading');
          button.classList.add('done');
          inputs.classList.add('success');
          inputs.classList.remove('error');
          dataLayer.push({
            'event': 'custom.event.subscribe-successful',
            'custom.gtm.signupSource': signupSource
          });
        }else{
          field.readOnly = false;
          button.classList.remove('loading');
          button.classList.add('ready');
          inputs.classList.add('error');
          inputs.classList.remove('success');
        }
      })


    })
  })


});
